import axios from "axios";
import { toast } from "react-toastify";
import {
  GET_ALL_BID_AUCTIONS,
  GET_ALL_CATEGORIES,
  GET_ALL_PAST_AUCTIONS,
  GET_ALL_RUNNING_AUCTIONS,
  GET_ALL_USERS,
  GET_BADGE_LISTS,
  GET_BID_TOTAL,
  GET_ITEM_LISTING,
  GET_ITEM_TOTAL,
  GET_PAST_TOTAL,
  GET_RUNNING_TOTAL,
  GET_SINGLE_STAFF,
  GET_STAFF_LISTING,
  GET_TOTAL_CATEGORIES,
  GET_TOTAL_USERS,
  USER_DISPUTES,
  USER_FLAG_COMMENTS,
} from "./userTypes";
import { start_loading, stop_loading } from "../loader/loaderAction";
import moment from "moment";
import { RESET_TOKEN } from "../auth/authTypes";
import apiClient from "../../api/apiClient";

const { REACT_APP_BASE_URL } = process.env;
const get_token = () => {
  let token = localStorage.getItem("token");
  return token;
};
// const token = get_token()
export const DESIGNATION = [
  {
    label: "Reviewer",
    value: "reviewers",
  },
  {
    label: "Manager",
    value: "managers",
  },
  {
    label: "Owner",
    value: "owners",
  },
];
export const show_success = (message) => {
  toast(message);
};

const headers = {
  "Content-Type": "application/json",
  "x-access-token": get_token(),
};

export const check_token_expired_logout = (data, dispatch) => {
  if (data?.request?.status === 401 || data?.request?.status === 403) {
    dispatch({ type: RESET_TOKEN, payload: true });
    localStorage.clear();
    window.location.reload();
  }
};

export const gotToExport = (data, label) => {
  const blob = new Blob([data], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `${label}(${moment()?.format("MMM DD, YYYY")?.replace(/,/g, "")}).csv`,
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const upload_image = async (dispatch, token, data) => {
  try {
    const urlPath = `add-item/mediaImage`;

    const res = await apiClient.post(urlPath, data);

    if (res?.data) {
      return res?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.log(error.response.data.error);
    console.error("Error:", error);
  }
};

export const get_export_users = async (dispatch, token, userId) => {
  dispatch(start_loading());
  try {
    const urlPath = `admin/export-user`;

    const res = await apiClient.post(urlPath, {
      userIds: userId ? [userId] : [],
    });

    if (res?.data) {
      return res?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.log(error.response.data.error);
    console.error("Error:", error);
  } finally {
    dispatch(stop_loading());
  }
};

export const update_password = async (userdata, token, dispatch) => {
  try {
    const urlPath = `profile/change-password`;

    const res = await apiClient.put(urlPath, userdata);

    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: "updatpwd", autoClose: 1000 });
      return true;
    } else {
      toast.error(res.data.message, {
        toastId: "updatedpwderr",
        autoClose: 1000,
      });
      return false;
    }
  } catch (error) {
    toast.error(error.response.data.error, {
      toastId: "updatedwwwww",
      autoClose: 1000,
    });
    // catch_errors_handle(error);
    console.log(error.response.data.error);
  }
};

export const get_export_sales = async (dispatch, token, userId, year) => {
  dispatch(start_loading());
  try {
    const urlPath = `admin/export-sales-report`;

    const res = await apiClient.post(urlPath, {
      user_id: userId === "ALL" ? null : userId,
      start_date: moment().year(year).startOf("year"),
      end_date: moment().year(year).endOf("year"),
    });

    if (res?.data) {
      return res?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.log(error.response.data.error);
    console.error("Error:", error);
  } finally {
    dispatch(stop_loading());
  }
};

export const withdraw_auction = async (dispatch, token, itemId) => {
  dispatch(start_loading());
  try {
    const urlPath = `admin/auction-withdrawn`;

    const res = await apiClient.put(urlPath, { itemId: itemId });

    if (res?.data) {
      return res?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.log(error.response.data.error);
  } finally {
    dispatch(stop_loading());
  }
};

export const get_users = async (
  dispatch,
  token,
  currentPage,
  perPage,
  name,
  email,
  username,
) => {
  try {
    const urlPath = `admin/usersList?page=${currentPage}&limit=${perPage}&name=${
      name ? name : ""
    }&email=${email ? email : ""}&username=${username ? username : ""}`;

    const res = await apiClient.get(urlPath);

    if (res?.data?.data) {
      dispatch({ type: GET_ALL_USERS, payload: res?.data?.data });
      dispatch({ type: GET_TOTAL_USERS, payload: res.data.total });
      return res?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.log(error.response.data.error);
    console.error("Error:", error);
  }
};

export const get_particular_user = async (id, token, dispatch) => {
  try {
    const urlPath = `admin/userDetails?userId=${id}`;

    const res = await apiClient.get(urlPath);

    if (res?.data?.data) {
      return res?.data?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
  }
};

export const searchUsersAPI = async (searchTerm) => {
  try {
    const res = await apiClient.get(
      `admin/search-users?searchTerm=${searchTerm}`,
    );
    if (res.data && res.data.status) {
      return res.data.users;
    }
    return [];
  } catch (error) {
    console.error("API Error searching users:", error);
    toast.error("Could not fetch users.");
    return [];
  }
};

export const sendNotificationAPI = async (payload) => {
  try {
    const res = await apiClient.post("admin/notify", payload);
    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    }
    toast.error(res.data.message || "An error occurred.");
    return false;
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Failed to send notification.",
    );
    return false;
  }
};

export const update_user = async (id, data, navigate, token, dispatch) => {
  if (data?.isDeactive === "Deactivate") {
    data.isDeactive = true;
  } else {
    data.isDeactive = false;
  }

  try {
    const urlPath = `admin/editUser?userId=${id}`;

    const res = await apiClient.put(urlPath, data);

    if (res?.data?.data) {
      show_success(res?.data?.message);
      navigate("/");
      return true;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
  }
};

export const delete_user = async (dispatch, token, userId) => {
  dispatch(start_loading());
  try {
    const urlPath = `admin/deletetUser?userId=${userId}`;

    const res = await apiClient.delete(urlPath);

    if (res?.data) {
      show_success(res?.data?.message);
      return true;
    }
  } catch (error) {
    console.log(error.response.data.error);
  } finally {
    dispatch(stop_loading());
  }
};

export const update_admin = async (data, navigate, token, dispatch) => {
  try {
    const urlPath = `admin/editAdminProfile`;

    const res = await apiClient.put(urlPath, data);

    if (res.status && res?.data?.data) {
      localStorage.setItem("profile", JSON.stringify(res?.data?.data));
      show_success("Profile Updated Successfully");
      setTimeout(() => {
        window.location.reload();
      }, 1200);
      return res?.data?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
  }
};

export const get_single_sell_Item = async (id, dispatch) => {
  try {
    const urlPath = `item/detail?slug=${id}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      return res.data.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
  }
};

export const edit_item_list = async (user, navigate, token) => {
  try {
    const urlPath = `item/add`;

    const res = await apiClient.post(urlPath, user);

    if (res?.data?.status) {
      navigate("/item-listing");
      show_success(res?.data?.message);
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    show_success(error?.response?.data?.messahe);
    console.log("Error");
    // Handle error here
  } finally {
  }
};

export const approve_auction = async (itemdata, navigate, token) => {
  try {
    const urlPath = `admin/approve_auction`;

    const res = await apiClient.put(urlPath, itemdata);

    if (res?.data && res?.data?.status) {
      navigate("/item-listing");
      show_success(res?.data?.message);
      return res;
    } else {
      toast.error(res?.data?.message || "Failed to approve auction.");
    }
  } catch (error) {
    console.error("Error:", error);
    toast.error(error?.response?.data?.error || "An error occurred.");
    console.log("Error");
  }
};

export const unapprove_auction = async (
  itemdata,
  navigate,
  token,
  dispatch,
) => {
  try {
    const urlPath = `admin/approve_auction`;

    const res = await apiClient.put(urlPath, itemdata);

    if (res?.data && res?.data?.status) {
      navigate("/item-listing");
      show_success(res?.data?.message);
      return res;
    }
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
  } finally {
  }
};

export const get_past_auctions = async (
  dispatch,
  token,
  page,
  limit,
  categories,
  search, // 1. Add new search parameter
) => {
  try {
    // 2. Conditionally add the search query to the URL
    const urlPath = `admin/past_auction?page=${page}&limit=${limit}${
      categories ? `&${categories}` : ""
    }${search ? `&search=${encodeURIComponent(search)}` : ""}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_ALL_PAST_AUCTIONS, payload: res?.data?.data });
      dispatch({ type: GET_PAST_TOTAL, payload: res.data.total });
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
  }
};

export const get_all_sell_Item = async (
  token,
  dispatch,
  page,
  limit,
  listtype,
  queryCat,
  search,
) => {
  try {
    const urlPath = `admin/list_for_approval?page=${page}&limit=${limit}&type=${listtype}${
      queryCat ? `&${queryCat}` : ""
    }${search ? `&search=${encodeURIComponent(search)}` : ""}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_ITEM_LISTING, payload: res.data.data });
      dispatch({ type: GET_ITEM_TOTAL, payload: res.data.total });
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
  }
};

export const get_running_auctions = async (
  dispatch,
  token,
  page,
  limit,
  categories,
  search,
) => {
  try {
    const urlPath = `admin/running_auction?page=${page}&limit=${limit}${
      categories ? `&${categories}` : ""
    }${search ? `&search=${encodeURIComponent(search)}` : ""}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_ALL_RUNNING_AUCTIONS, payload: res?.data?.data });
      dispatch({ type: GET_RUNNING_TOTAL, payload: res?.data?.total });
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
  }
};

export const manage_sub_category = async (data, token, dispatch, id) => {
  try {
    const urlPath = id
      ? `/admin/sub_edit_category/${id}`
      : `/admin/sub_category`;

    const response = await apiClient.post(urlPath, data);

    if (response?.status >= 200 && response?.status < 300) {
      show_success(response?.data?.message);
    } else {
      throw new Error("Network response was not ok");
    }
    return response;
  } catch (error) {
    console.log(error.response.data.error);
  }
};

export const add_category = async (data, token, dispatch) => {
  try {
    const urlPath = `admin/add_category`;

    const response = await apiClient.post(urlPath, data);

    // Check if the response is successful (status code 2xx)
    if (response?.status >= 200 && response?.status < 300) {
      show_success(response?.data?.message);
    } else {
      throw new Error("Network response was not ok");
    }

    return response;
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
    throw error; // Rethrow the error to handle it in the calling code if needed
  }
};

export const edit_category = async (data, token, id, dispatch) => {
  try {
    const urlPath = `admin/edit_category/${id}`;

    const response = await apiClient.put(urlPath, data);

    if (!response?.data?.status) {
      throw new Error("Network response was not ok");
    } else {
      show_success(response?.data?.message);
    }

    return response;
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
  }
};

export const update_category_settings = async (data, token, dispatch) => {
  try {
    const urlPath = `admin/category/settings`;

    const response = await apiClient.put(urlPath, data);

    if (!response?.data?.status) {
      throw new Error("Network response was not ok");
    } else {
      show_success(response?.data?.message);
    }

    return response;
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response?.data?.error);
  }
};

export const apply_feature_category = async (data, token, id, dispatch) => {
  try {
    const urlPath = `admin/edit_category/${id}`;

    const response = await apiClient.put(urlPath, data);

    if (response.data && response?.data?.status) {
      toast.success(response.data.message, { toastId: "succesone" });
    }
  } catch (error) {
    toast.error(error.response.data.message, { toastId: "suceestwo" });
    console.error("Error:", error);
    console.log(error.response.data.error);
  }
};

export const get_category = async (dispatch, token, page, limit) => {
  try {
    const urlPath = `admin/list_category?page=${page}&limit=${limit}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_ALL_CATEGORIES, payload: res.data.data });
      dispatch({ type: GET_TOTAL_CATEGORIES, payload: res.data.total });
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
  }
};

export const delete_category = async (id, token, dispatch) => {
  try {
    const urlPath = `admin/delete_category?categoryId=${id}`;

    const res = await apiClient.delete(urlPath);

    if (res.data && res.data.status) {
      show_success(res?.data?.message);
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
  }
};

export const get_all_auction_category = async () => {
  try {
    const urlPath = `admin/list_category`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      return res.data.data;
    } else {
    }
  } catch (error) {
    console.log("Error");
  }
};

export const sell_video_game = async (userdata, dispatch) => {
  try {
    const urlPath = `item/add`;

    const res = await apiClient.post(urlPath, userdata);

    if (res.data && res.data.status) {
      toast.success(res.data.message, {
        toastId: "itemupdetsws",
        autoClose: 2000,
      });
      return true;
    } else {
      toast.error(res.data.message);
      return false;
    }
  } catch (error) {
    // console.log("//////////////", error)
    console.log(error.response.data.error);
  }
};

export const upload_sell_item_photo = async (photo, token, dispatch) => {
  const formData = new FormData();

  photo.forEach((v) => {
    formData.append(`photos`, v);
  });
  formData.append("type", "item/image");

  try {
    const urlPath = `add-item/mediaImage`;

    const res = await apiClient.post(urlPath, formData);

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return res;
    } else {
      toast.error(res.error, { toastId: "editphotoerrr", autoClose: 2000 });
      return false;
    }
  } catch (error) {
    toast.error(error.response.data.message);
    // catch_errors_handle(error);
    console.log(error.response.data.error);
  }
};

export const upload_rich_text_image = async (file, token, dispatch) => {
  const formData = new FormData();
  formData.append("image", file);

  const urlPath = `admin/upload-rich-text-image`;

  const res = await apiClient.post(urlPath, formData);

  if (res.data && res.data.status) {
    toast.success(res.data.message);
    return res;
  } else {
    toast.error(res.error, { toastId: "editrichtextimage", autoClose: 2000 });
    return false;
  }
};

export const upload_public_doc = async (photo, token, dispatch) => {
  const formData = new FormData();

  photo.forEach((v) => {
    formData.append(`public_file`, v);
  });

  try {
    const urlPath = `upload-public-doc`;

    const res = await apiClient.post(urlPath, formData);

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return res;
    } else {
      toast.error(res.data.error, {
        toastId: "editphotoerrr",
        autoClose: 2000,
      });
      return false;
    }
  } catch (error) {
    toast.error(error.response.data.message);
    console.log(error.response.data.error);
  }
};

export const upload_edit_item_video = async (video, token, dispatch) => {
  // dispatch(start_loading());
  try {
    const formData = new FormData();
    video.forEach((v) => {
      formData.append(`video`, v);
    });
    formData.append("type", "item/video");

    const urlPath = `add-item/videoupload`;

    const res = await apiClient.post(urlPath, formData);

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return res;
    } else {
      toast.error(res.error, { toastId: "editvideoerrr", autoClose: 2000 });
      return false;
    }
  } catch (error) {
    toast.error(error.response.data.message);
    console.log(error.response.data.error);
  } finally {
    // dispatch(stop_loading());
  }
};

export const upload_sell_item_logal_docs = async (
  legal_doc,
  token,
  dispatch,
) => {
  try {
    const formData = new FormData();
    legal_doc.forEach((doc) => {
      formData.append("legal_doc", doc);
    });
    formData.append("type", "item/legalDocs");

    // formData.append('legal_doc', legal_doc);
    const urlPath = `add-item/legaldocs`;

    const res = await apiClient.post(urlPath, formData);

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return res;
    } else {
      toast.error(res.data.message);
      return false;
    }
  } catch (error) {
    console.log(error.response.data.error);
  }
};

export const get_all_bid_items = async (
  dispatch,
  token,
  search,
  page,
  limit,
) => {
  try {
    const urlPath = `item/all_items?search=${
      search ? search : ""
    }&page=${page}&limit=${limit}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_ALL_BID_AUCTIONS, payload: res.data.data });
      dispatch({ type: GET_BID_TOTAL, payload: res.data.total });
      return res;
    }
  } catch (error) {
    console.log("bid management", error);
    console.log(error.response.data.error);
  }
};

export const get_item_bid_detail = async (itemId, token, dispatch) => {
  try {
    const urlPath = `item/all_bids?itemId=${itemId}`;

    const res = await apiClient.get(urlPath);

    return res;
  } catch (error) {
    console.log(error.response.data.error);
  }
};

//badge apis

export const get_badge_lists = async (token, dispatch) => {
  try {
    const urlPath = `admin/list-badge`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_BADGE_LISTS, payload: res.data.data });
    }
  } catch (error) {
    console.log(error.response.data.error);
  }
};

export const add_badge = async (token, badge_data, badgeId, dispatch) => {
  try {
    const urlPath = badgeId
      ? `admin/update-badge/${badgeId}`
      : `admin/add-badge`;

    const res = await (badgeId
      ? apiClient.put(urlPath, badge_data)
      : apiClient.post(urlPath, badge_data));

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    }
  } catch (error) {
    console.log(error.response.data.error);
  }
};

export const delete_badge = async (token, badgeId, dispatch) => {
  try {
    const urlPath = `admin/delete-badge/${badgeId}`;

    const res = await apiClient.delete(urlPath);

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    }
  } catch (error) {
    console.log(error.response.data.error);
  }
};

export const delete_faq_question = async (token, faqId, dispatch) => {
  try {
    const url = `${REACT_APP_BASE_URL}admin/delete-content/seller`;
    const HEADERS = {
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      data: { id: faqId },
    };

    const res = await axios.delete(url, HEADERS);
    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    }
  } catch (error) {
    toast.error(error.response.data.message, {
      toastId: "deltefaw",
      autoClose: 2000,
    });
    console.log(error.response.data.error);
  }
};

export const get_user_sales_history = async (token, data, dispatch) => {
  try {
    const urlPath = `user/sales-report`;

    const res = await apiClient.post(urlPath, data);

    if (res.data && res.data.status) {
      // console.log(res.data);
      return res.data.data;
    } else {
    }
  } catch (error) {
    toast.error(error.response.data.error, {
      toastId: "saleshistiewr",
      autoClose: 2000,
    });
    console.log(error.response.data.error);
  }
};

export const get_all_staff = async (
  token,
  dispatch,
  page,
  limit,
  search,
  uid,
) => {
  try {
    const urlPath = `admin/staff-list?page=${page}&limit=${limit}${
      search ? `&search=${search}` : ""
    }`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_STAFF_LISTING, payload: { ...res.data, uid: uid } });
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
  }
};

export const get_staff = async (token, dispatch, id) => {
  try {
    const urlPath = `admin/get-staff/${id}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_SINGLE_STAFF, payload: res.data.data });
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    console.log(error.response.data.error);
  }
};

export const manage_staff = async (token, data, id, dispatch) => {
  try {
    const urlPath = id ? `admin/editUser?userId=${id}` : `admin/create-staff`;

    const res = await (id
      ? apiClient.put(urlPath, data)
      : apiClient.post(urlPath, data));

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      get_all_staff(token, dispatch, 1, 10, null);
      return true;
    } else {
      toast.error(res.data.error, {
        toastId: "errorsearchsaved",
        autoClose: 1000,
      });
      return false;
    }
  } catch (error) {
    console.error("Error:", error);
    //toast.error(error.response.data.error || error.response.data.message, { toastId: "errorsearchsaved", autoClose: 1000 });
    console.log(error.response.data.error);
  }
};

export const user_dispute = async (
  dispatch,
  page,
  limit,
  search,
  method,
  data,
) => {
  try {
    let res;
    let urlPath = "";

    switch (method) {
      case "get":
        urlPath = `admin/dispute-list?page=${page}&limit=${limit}${
          search ? `&search=${search}` : ""
        }`;
        res = await apiClient.get(urlPath);
        break;

      case "resolve":
        urlPath = `admin/dispute/resolve/${data.id}`;
        res = await apiClient.put(urlPath, {
          resolution: data.resolution,
          resolutionAction: data.resolutionAction,
        });
        break;

      case "put":
        urlPath = `admin/change-status`;
        res = await apiClient.put(urlPath, data);
        break;

      default:
        throw new Error(`Unknown dispute method: ${method}`);
    }

    if (res.data && res.data.status) {
      if (method === "get") {
        dispatch({ type: USER_DISPUTES, payload: res.data });
      } else {
        toast.success(res.data.message, {
          toastId: "disputeSuccess",
          autoClose: 1500,
        });

        user_dispute(dispatch, page, limit, "", "get", null);
        return true;
      }
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.error ||
      "An error occurred with the dispute request.";
    toast.error(errorMessage, {
      toastId: "disputeError",
      autoClose: 2000,
    });
    console.error("Dispute Action Error:", error);
  }
};

export const user_flag_comments = async (
  dispatch,
  token,
  page,
  limit,
  search,
  method,
  data,
) => {
  try {
    const urlPath =
      method === "get"
        ? `item/flag-Comments?page=${page}&limit=${limit}${
            search ? `&search=${search}` : ""
          }`
        : `item/flag-Comments-status`;

    const res = await (method === "get"
      ? apiClient.get(urlPath)
      : apiClient.post(urlPath, data));

    if (res.data && res.data.status) {
      if (method == "get") {
        dispatch({ type: USER_FLAG_COMMENTS, payload: res.data });
      } else {
        toast.success("Succussfully updated flag comment status!", {
          toastId: "savedsearchshs",
          autoClose: 1000,
        });
        return true;
      }
    }
  } catch (error) {
    toast.error(error.response.data.error, {
      toastId: "errorsearchsaved",
      autoClose: 1000,
    });
    console.log(error.response.data.error);
    return false;
  }
};

export const getPendingFlagsAPI = async (page = 1, limit = 10) => {
  try {
    const res = await apiClient.get(
      `admin/flags/pending?page=${page}&limit=${limit}`,
    );

    if (res.data && res.data.status) {
      return res.data;
    } else {
      toast.error(res.data.message || "Could not fetch reports.");
      return { data: [], total: 0 };
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to load reports.");
    console.error("API Error fetching pending flags:", error);
    return null;
  }
};

export const reviewFlagAPI = async (payload) => {
  try {
    const res = await apiClient.post("admin/flags/review", payload);

    if (res.data && res.data.status) {
      return true;
    } else {
      toast.error(
        res.data.message || "An error occurred while reviewing the report.",
      );
      return false;
    }
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Failed to review the report.",
    );
    console.error("API Error reviewing flag:", error);
    return false;
  }
};
export const get_store_requests = async (status = "") => {
  try {
    const url = status
      ? `/admin/store-requests?status=${status}`
      : "/admin/store-requests";
    const res = await apiClient.get(url);
    if (res.data && res.data.status) {
      return res.data.data;
    }
    return [];
  } catch (error) {
    toast.error(
      error.response?.data?.error || "Failed to load store requests.",
    );
    console.error("API Error fetching store requests:", error);
    return [];
  }
};

export const get_store_request_details = async (id) => {
  try {
    const res = await apiClient.get(`/admin/store-requests/${id}`);
    if (res.data && res.data.status) {
      return res.data.data;
    }
    return null;
  } catch (error) {
    toast.error(
      error.response?.data?.error || "Failed to load request details.",
    );
    console.error("API Error fetching request details:", error);
    return null;
  }
};

export const update_store_request = async (id, payload) => {
  try {
    const res = await apiClient.put(`/admin/store-requests/${id}`, payload);
    if (res.data && res.data.status) {
      return res.data;
    }
    return null;
  } catch (error) {
    toast.error(error.response?.data?.error || "Failed to update request.");
    console.error("API Error updating store request:", error);
    return null;
  }
};

export const save_admin_notes = async (id, adminNotes) => {
  try {
    const res = await apiClient.put(`/admin/store-requests/${id}/notes`, {
      adminNotes,
    });
    if (res.data && res.data.status) {
      toast.success("Notes saved successfully!");
      return res.data;
    }
    return null;
  } catch (error) {
    toast.error(error.response?.data?.error || "Failed to save notes.");
    console.error("API Error saving notes:", error);
    return null;
  }
};

export const get_secure_document_url = async (fileKey) => {
  try {
    const res = await apiClient.get(
      `/admin/secure-document-url?key=${fileKey}`,
    );
    if (res.data && res.data.status) {
      return res.data.url;
    }
    return null;
  } catch (error) {
    toast.error("Could not get secure link for document.");
    console.error("API Error getting secure URL:", error);
    return null;
  }
};

export const getAwardsAPI = async () => {
  try {
    const res = await apiClient.get("admin/list-award");

    if (res.data && res.data.status) {
      return res.data.data;
    } else {
      toast.error(res.data.message || "Could not fetch awards.");
      return [];
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to load awards.");
    console.error("API Error fetching awards:", error);
    return null;
  }
};

export const createAwardAPI = async (awardData) => {
  try {
    const res = await apiClient.post("admin/add-award", awardData);

    if (res.data && res.data.status) {
      toast.success("Award created successfully!");
      return res.data.data;
    } else {
      toast.error(res.data.message || "Could not create award.");
      return null;
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to create award.");
    console.error("API Error creating award:", error);
    return null;
  }
};

export const grantAwardAPI = async (userId, awardId) => {
  try {
    const res = await apiClient.post("admin/grant-award", { userId, awardId });

    if (res.data && res.data.status) {
      toast.success(res.data.message || "Award granted successfully!");
      return true;
    } else {
      toast.error(res.data.message || "Could not grant award.");
      return false;
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to grant award.");
    console.error("API Error granting award:", error);
    return false;
  }
};

export const getEventsAPI = async () => {
  try {
    const res = await apiClient.get("admin/events");
    if (res.data && res.data.status) {
      return res.data.events;
    }
    return [];
  } catch (error) {
    toast.error("Could not fetch events.");
    return [];
  }
};

export const createEventAPI = async (name) => {
  try {
    const res = await apiClient.post("admin/events", { name });
    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    }
    toast.error(res.data.message || "Could not create event.");
    return false;
  } catch (error) {
    toast.error("An error occurred while creating the event.");
    return false;
  }
};

export const setActiveEventAPI = async (eventId) => {
  try {
    const res = await apiClient.put(`admin/events/${eventId}/activate`);
    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    }
    toast.error(res.data.message || "Could not activate event.");
    return false;
  } catch (error) {
    toast.error("An error occurred while activating the event.");
    return false;
  }
};

export const getGroupDetailsAPI = async (groupId) => {
  try {
    const res = await apiClient.get(`admin/groups/${groupId}`);
    if (res.data && res.data.status) {
      return res.data.group;
    }
    return null;
  } catch (error) {
    toast.error("Could not fetch group details.");
    return null;
  }
};

export const addUserToGroupAPI = async (groupId, userId) => {
  try {
    const res = await apiClient.put(`admin/groups/${groupId}/add-member`, {
      userId,
    });
    if (res.data?.status) {
      toast.success(res.data.message);
      return true;
    }
    toast.error(res.data.message || "Failed to add user.");
    return false;
  } catch (error) {
    toast.error("An error occurred while adding the user.");
    return false;
  }
};

export const grantAwardToGroupAPI = async (groupId, awardId) => {
  try {
    const res = await apiClient.post(`admin/groups/${groupId}/grant-award`, {
      awardId,
    });
    if (res.data?.status) {
      toast.success(res.data.message);
      return true;
    }
    toast.error(res.data.message || "Failed to grant award.");
    return false;
  } catch (error) {
    toast.error("An error occurred while granting the award.");
    return false;
  }
};

export const updateGroupAPI = async (groupId, updateData) => {
  try {
    const res = await apiClient.put(`admin/groups/${groupId}`, updateData);

    if (res.data?.status) {
      toast.success(res.data.message || "Group updated successfully!");
      return true;
    }
    toast.error(res.data.message || "Failed to update group.");
    return false;
  } catch (error) {
    toast.error("An error occurred while updating the group.");
    return false;
  }
};

export const updateAwardAPI = async (awardId, awardData) => {
  try {
    const res = await apiClient.put(`admin/update-award/${awardId}`, awardData);

    if (res.data && res.data.status) {
      toast.success("Award updated successfully!");
      return res.data.data;
    } else {
      toast.error(res.data.message || "Could not update award.");
      return null;
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to update award.");
    console.error("API Error updating award:", error);
    return null;
  }
};

export const deleteAwardAPI = async (awardId) => {
  try {
    const res = await apiClient.delete(`admin/delete-award/${awardId}`);

    if (res.data && res.data.status) {
      toast.success("Award deleted successfully!");
      return true;
    } else {
      toast.error(res.data.message || "Could not delete award.");
      return false;
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to delete award.");
    console.error("API Error deleting award:", error);
    return false;
  }
};

export const uploadAwardImageAPI = async (formData) => {
  try {
    const res = await apiClient.post("admin/upload-award-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (res.data && res.data.status) {
      toast.success(res.data.message || "Image uploaded successfully!");
      return res.data;
    } else {
      toast.error(res.data.message || "Could not upload image.");
      return null;
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Image upload failed.");
    console.error("API Error uploading image:", error);
    return null;
  }
};

export const getNewsletterEmails = async () => {
  try {
    const res = await apiClient.get(`admin/newsletter-emails`);
    console.log(res);
    if (res.data && res.data.status) {
      return res.data.data;
    }
    return [];
  } catch (error) {
    console.error("API Error searching users:", error);
    toast.error("Could not fetch users.");
    return [];
  }
};

export const get_all_shipments = async () => {
  try {
    const urlPath = `admin/all-shipments`;
    const res = await apiClient.get(urlPath);

    if (res?.data && res?.data?.status) {
      return res.data.data;
    } else {
      toast.error(res?.data?.message || "Failed to fetch shipments.");
      return [];
    }
  } catch (error) {
    console.error("Error fetching shipments:", error);
    toast.error(error?.response?.data?.error || "An error occurred.");
    console.log("Error");
    return [];
  }
};

export const get_completed_auctions = async () => {
  try {
    const urlPath = `admin/completed-auctions`;
    const res = await apiClient.get(urlPath);

    if (res?.data && res?.data?.status) {
      return res.data.data;
    } else {
      toast.error(res?.data?.message || "Failed to fetch completed auctions.");
      return [];
    }
  } catch (error) {
    console.error("Error fetching auctions:", error);
    toast.error(error?.response?.data?.error || "An error occurred.");
    console.log("Error");
    return [];
  }
};

export const create_shipment = async (payload) => {
  try {
    const urlPath = `admin/create-shipment`;
    const res = await apiClient.post(urlPath, payload);

    if (res?.data && res?.data?.status) {
      show_success(res.data.message || "Shipment created successfully!");
      return res.data.data;
    } else {
      toast.error(res?.data?.message || "Failed to create shipment.");
      return null;
    }
  } catch (error) {
    console.error("Error creating shipment:", error);
    toast.error(error?.response?.data?.error || "An error occurred.");
    console.log("Error");
    return null;
  }
};

export const add_manual_tracking_update = async (shippingId, payload) => {
  try {
    const urlPath = `admin/update-manual-tracking/${shippingId}`;
    const res = await apiClient.put(urlPath, payload);

    if (res?.data && res?.data?.status) {
      show_success(res.data.message || "Tracking updated!");
      return res.data.data;
    } else {
      toast.error(res?.data?.message || "Failed to update tracking.");
      return null;
    }
  } catch (error) {
    console.error("Error updating tracking:", error);
    toast.error(error?.response?.data?.error || "An error occurred.");
    console.log("Error");
    return null;
  }
};

export const change_shipment_type = async (shippingId, shippingType) => {
  try {
    const urlPath = `admin/shipments/${shippingId}/change-type`;
    const res = await apiClient.put(urlPath, { shippingType });

    if (res?.data && res?.data?.status) {
      show_success(res.data.message || "Shipment type updated!");
      return res.data.data;
    } else {
      toast.error(res?.data?.message || "Failed to update shipment type.");
      return null;
    }
  } catch (error) {
    console.error("Error updating shipment type:", error);
    toast.error(error?.response?.data?.error || "An error occurred.");
    console.log("Error");
    return null;
  }
};

export const get_pending_shipments = async () => {
  try {
    const urlPath = `admin/pending-shipments`;
    const res = await apiClient.get(urlPath);
    if (res?.data?.status) {
      return res.data.data;
    } else {
      toast.error(res?.data?.message || "Failed to fetch pending shipments.");
      return [];
    }
  } catch (error) {
    console.error("Error fetching pending shipments:", error);
    toast.error(error?.response?.data?.error || "An error occurred.");
    console.log("Error");
    return [];
  }
};

export const get_admin_dashboard_counts = async (dispatch) => {
  try {
    const urlPath = `admin/dashboard-counts`;

    const res = await apiClient.get(urlPath);

    if (res.data) {
      return res.data;
    } else {
      console.log("Error fetching dashboard counts: No data in response");
      return null;
    }
  } catch (error) {
    console.error("Error in get_admin_dashboard_counts:", error);
    console.log(error.response.data.error);
    return null;
  }
};

export const getConversationsAdminAPI = async (params) => {
  try {
    const res = await apiClient.get("admin/conversations", { params });
    if (res.data) {
      return res.data;
    }
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Failed to fetch conversations.",
    );
    return { conversations: [], pagination: {} };
  }
};

export const getConversationByIdAdminAPI = async (conversationId) => {
  try {
    const res = await apiClient.get(`admin/conversations/${conversationId}`);
    if (res.data) {
      return res.data;
    }
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Failed to fetch conversation details.",
    );
    return null;
  }
};

export const createConversationAdminAPI = async (payload) => {
  try {
    const res = await apiClient.post("admin/conversations", payload);
    if (res.data) {
      toast.success(res.data.message);
      return res.data.conversation;
    }
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Failed to create conversation.",
    );
    return null;
  }
};

export const searchItemsAPI = async (term) => {
  try {
    const res = await apiClient.get(`items/search?name=${term}`);
    return res.data.items;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to search for items.");
    return [];
  }
};
export const revertItemToPendingAPI = async (itemId) => {
  try {
    const res = await apiClient.put(`/admin/items/${itemId}/revert-to-pending`);
    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    }
    toast.error(res.data.message || "An error occurred.");
    return false;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to revert item.");
    return false;
  }
};

export const create_quick_auction = async (data, dispatch) => {
  try {
    const res = await apiClient.post("admin/quick-auction", data);

    if (res.data && res.data.status) {
      toast.success(res.data.message || "Quick Auction created successfully!", {
        toastId: "quickAuctionSuccess",
        autoClose: 2000,
      });
      return true;
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.error ||
      "An error occurred with the quick auction request.";
    toast.error(errorMessage, {
      toastId: "quickAuctionError",
      autoClose: 3000,
    });
    console.error("Quick Auction Action Error:", error.response || error);
    return false;
  }
};

export const getAutoBidListAPI = async (
  page = 1,
  limit = 10,
  userSearch = "",
  itemSearch = "",
) => {
  try {
    const queryParams = new URLSearchParams({
      page,
      limit,
    });

    if (userSearch) queryParams.append("userSearch", userSearch);
    if (itemSearch) queryParams.append("itemSearch", itemSearch);

    const res = await apiClient.get(
      `data/autobid_list?${queryParams.toString()}`,
    );

    if (res.data && res.data.status) {
      return res.data;
    } else {
      toast.error(res.data.message || "Could not fetch auto-bids.");
      return { data: [], total: 0 };
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to load auto-bids.");
    console.error("API Error fetching auto-bids:", error);
    return null;
  }
};

export const get_affiliates_action = async (status, search = "") => {
  try {
    let url = `admin/affiliates?status=${status}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    const res = await apiClient.get(url);

    if (res.data && res.data.status) {
      return res.data.data;
    }
    return [];
  } catch (error) {
    console.error("Fetch Affiliates Error:", error);

    if (error.response?.status === 403) {
      toast.error("You are not authorized to view this page.", {
        toastId: "authError",
        autoClose: 3000,
      });
    }
    return [];
  }
};

export const create_affiliate_action = async (data) => {
  try {
    const res = await apiClient.post(`admin/affiliate/create`, data);

    if (res.data && res.data.status) {
      toast.success("Affiliate created successfully!");
      return true;
    } else {
      toast.error(res.data.error || "Failed to create affiliate.");
      return false;
    }
  } catch (error) {
    console.error("Create Affiliate Error:", error);
    toast.error(
      error.response?.data?.error || "Server error while creating affiliate.",
    );
    return false;
  }
};

export const update_affiliate_status_action = async (id, data) => {
  try {
    const payload = { id, ...data };

    const res = await apiClient.put(`admin/affiliate/review`, payload);

    if (res.data && res.data.status) {
      toast.success(`Application ${data.decision} successfully.`);
      return true;
    } else {
      toast.error(res.data.error || "Action failed.");
      return false;
    }
  } catch (error) {
    console.error("Update Status Error:", error);
    toast.error(error.response?.data?.error || "Server error.");
    return false;
  }
};

export const update_campaign_settings_action = async (id, settings) => {
  try {
    const res = await apiClient.put(`admin/affiliate/${id}/settings`, settings);

    if (res.data && res.data.status) {
      toast.success(res.data.message || "Settings saved successfully!", {
        toastId: "affSettingsSuccess",
        autoClose: 2000,
      });
      return true;
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.error || "Failed to save settings.";
    toast.error(errorMessage, {
      toastId: "affSettingsError",
      autoClose: 3000,
    });
    console.error("Affiliate Settings Action Error:", error);
    return false;
  }
};

export const record_payout_action = async (id, payoutData) => {
  try {
    const res = await apiClient.post(
      `admin/affiliate/${id}/payout`,
      payoutData,
    );

    if (res.data && res.data.status) {
      toast.success(res.data.message || "Payout recorded successfully!", {
        toastId: "payoutSuccess",
        autoClose: 2000,
      });
      return true;
    }
  } catch (error) {
    const errorMessage =
      error.response?.data?.error || "Failed to record payout.";
    toast.error(errorMessage, {
      toastId: "payoutError",
      autoClose: 3000,
    });
    console.error("Affiliate Payout Action Error:", error);
    return false;
  }
};

export const saveHallOfFame = async (items) => {
  try {
    const res = await apiClient.post("/admin/hall-of-fame", { items });
    if (res.data && res.data.status) {
      toast.success("Hall of Fame updated successfully!");
      return true;
    }
    return false;
  } catch (error) {
    console.error("Save failed", error);
    toast.error(error.response?.data?.error || "Failed to save.");
    return false;
  }
};

export const get_all_payment_plans = async (filters = {}) => {
  try {
    const queryString = new URLSearchParams(filters).toString();
    const urlPath = `payment-plans/admin/all?${queryString}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      return res.data.data;
    } else {
      return [];
    }
  } catch (error) {
    console.log("Error fetching payment plans", error);
    return [];
  }
};

export const update_payment_plan_logistics = async (planId, data) => {
  try {
    const urlPath = `payment-plans/admin/${planId}/logistics`;
    const res = await apiClient.patch(urlPath, data);

    if (res.data && res.data.status) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.log("Error updating logistics", error);
    return false;
  }
};

export const get_all_bids = async (page = 1, limit = 20, search = "") => {
  try {
    const res = await apiClient.get(
      `admin/bids?page=${page}&limit=${limit}&search=${search}`,
    );
    if (res.data && res.data.status) {
      return res.data;
    }
    return null;
  } catch (error) {
    console.error("Error fetching bids:", error);
    return null;
  }
};

export const cancel_bid_action = async (bidId) => {
  try {
    const res = await apiClient.post(`admin/cancel-bid`, { bidId });
    if (res.data && res.data.status) {
      toast.success("Bid cancelled successfully. Auction recalculated.");
      return true;
    } else {
      toast.error(res.data.error || "Failed to cancel bid.");
      return false;
    }
  } catch (error) {
    console.error("Error cancelling bid:", error);
    toast.error(error.response?.data?.error || "Server Error");
    return false;
  }
};
